// extracted by mini-css-extract-plugin
export default {"setting":"Rules_setting__NnlOt","input":"Rules_input__C4STV","label":"Rules_label__E+EmU"};